// import Inbox from './components/Inbox'
const Index = () => import(/* webpackChunkName: "home" */ './index.vue');
// const Edit = () => import( /* webpackChunkName: "home" */ '@/modules/Member/components/Edit.vue');
export default [
  {
    path: '/',
    name: 'home',
    component: Index,
    title: 'Home',
    // redirect: { name: 'inbox-view' },
  },
  // {
  //   path: 'edit',
  //   name: 'member-edit',
  //   component: Edit,
  // },
]
